module.exports = __webpack_public_path__ + "img/BS01.3e054ade.svg";